// globals/helpers/iconProgress.ts
import { reactive, computed } from "vue";

const state = reactive({
  active: false,
  total: 0,
  done: 0,
  failed: 0,
  bytes: 0,
  startedAt: 0,
});

export const iconProgress = {
  state,
  start(total: number) {
    Object.assign(state, {
      active: true,
      total,
      done: 0,
      failed: 0,
      bytes: 0,
      startedAt: Date.now(),
    });
  },
  tick(bytes: number, ok: boolean) {
    state.done++;
    if (!ok) state.failed++;
    state.bytes += bytes;
  },
  finish() {
    state.active = false;
  },
};

const elapsed = () => (Date.now() - state.startedAt) / 1000;

export const iconSpeedKBs = computed(() => {
  const s = elapsed();
  return s > 0 ? Math.round(state.bytes / 1024 / s) : 0;
});

export const iconEtaSeconds = computed(() => {
  const s = elapsed();
  if (state.done === 0 || s <= 0) return null;
  return Math.ceil((state.total - state.done) / (state.done / s));
});

export const iconProgressRatio = computed(() =>
  state.total > 0 ? state.done / state.total : 0,
);

export const iconProgressMessage = computed(() => {
  if (!state.active) return "";
  const parts = [`${state.done}/${state.total}`];
  if (iconSpeedKBs.value > 0) parts.push(`${iconSpeedKBs.value} KB/s`);
  const eta = iconEtaSeconds.value;
  if (eta !== null && eta > 0) parts.push(`~${eta}s`);
  return parts.join(" · ");
});
